import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  change(event: Event) {
    const colourSchemeValue = (event.target as HTMLInputElement).value;
    const tagsWithoutMediaAttr = document.querySelectorAll("meta[name='theme-color']:not([media])");

    localStorage.setItem('de-colour-scheme', colourSchemeValue);

    for (const tag of tagsWithoutMediaAttr) {
      tag.remove();
    }

    if (colourSchemeValue === "light" || colourSchemeValue === "dark") {
      const firstMetaThemeTag = document.querySelector("meta[name='theme-color']") as HTMLMetaElement;
      const metaThemeColor = colourSchemeValue === "light" ? getComputedStyle(document.body).getPropertyValue("--colour-white") : getComputedStyle(document.body).getPropertyValue("--colour-black");

      const newMetaElement = document.createElement("meta");
      newMetaElement.name = "theme-color";
      newMetaElement.content = metaThemeColor;

      firstMetaThemeTag.insertAdjacentElement("beforebegin", newMetaElement);
    }
  }
}
